module.exports = __webpack_public_path__ + "static/media/back-icon.3943b3fa.svg";